export default __webpack_public_path__ + "static/media/animation021-02.005287dd.svg";